<template>
<md-toolbar class="md-denso header-top-nav" md-elevation="0">
    <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
             <div class="img-logo md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }">
                <img :src="logo" />
            </div>
            <h1 class="md-title visible-on-sidebar-mini">POP CARD</h1>
        </div>
        <div class="md-toolbar-section-end">
            <md-button  @click.native="logout" class="md-simple md-danger" style="margin-right: -30px">
                <i class="fas fa-power-off"></i>
                <md-tooltip md-direction="top">Sair</md-tooltip>
            </md-button>
            <md-button class="md-just-icon md-round md-simple md-toolbar-toggle" :class="{ toggled: $sidebar.showSidebar }" @click="toggleSidebar">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </md-button>
        </div>
    </div>
</md-toolbar>
</template>

<script>
export default {
    data() {
        return {
            logo: "./img/logo2.png"
        }
    },

    methods: {
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        logout() {
            this.$http.get(this.$urlAPI + 'logout')
            localStorage.clear();
            this.$store.commit('setUsuario', null)
            this.$router.push({
                name: 'login'
            });
        }
    }
}
</script>

<style>
.header-top-nav {
    background-color: #002bdc !important;
    padding: 0px;
    margin-bottom: -25px !important;
}
.img-logo{
    min-width: 50% !important;
    padding: 0px, 5px;
}
</style>
